<template>
    <div v-if="availability">
        <b-modal id="availabilityModal" :title="title" size="md" v-model="dialogOpen" @hidden="onDialogHidden" ok-only>
            
            <p>Time Zone: {{ timeZoneDisplayString }}</p>
            <div v-for="(slot,index) in availability.timeSlots" :key="index" class="float-left w-25 pl-2 pr-2">
                <b-form-checkbox size="sm" style="border: 1px solid #AAA;" @change="availabilityUpdated=true" v-model="slot.selected" v-bind:class="getTimeSlotBackground(slot.timeSlotValue)" v-if="slot.timeSlotValue<800 || slot.timeSlotValue > 1730" :disabled="isPastDate()">
                    {{ slot.timeSlotStartDisplayText }}
                </b-form-checkbox>
                <b-form-checkbox size="sm" class="font-weight-bold" @change="availabilityUpdated=true" style="border: 1px solid #AAA;clear:both;" v-model="slot.selected" v-bind:class="getTimeSlotBackground(slot.timeSlotValue)" v-else :disabled="isPastDate()">
                    {{ slot.timeSlotStartDisplayText }}
                </b-form-checkbox>
            </div>

            <template #modal-footer>
                <div class="w-100">
                    <!-- SAVE button only shows when dialog is opened from the AvailabilityCalendar -->
                    <b-button size="sm" @click="saveAvailability" v-if="dayToEdit==null && !isPastDate()" :disabled="!availabilityUpdated" variant="success" class="float-right">Save</b-button>
                    <b-button size="sm" @click="dialogOpen=false" variant="secondary" class="float-right mr-1">Close</b-button>
                    <b-button size="sm" @click="toggleCheckboxes" v-if="!isPastDate()" variant="warning" class="float-left">{{ toggleButtonLabel }}</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';

    Vue.use(BootstrapVue);
    Vue.use(BootstrapVueIcons);

    export default {
        name: 'AvailabilityDayEdit',
        mixins: [ErrorsMixin, DateTimeMixin],
        model: {
            event: 'change',
            prop: 'active',
        },
        props: {
            apiControllerUrl: {
                type: String,
                required: true
            },
            title: {
                type: String,
                default: 'no title'
            },
            // incoming prop from AvailabilityCalendar.vue
            dateToEdit: {
                type: Date,
                default: null
            },
            dayToEdit: {
                type: Object,
                default: null
            },
            weekNr: {
                type: Number,
                default: null
            },
            userAccountId: {
                type: String,
                default: null
            },
            timeZoneDisplayString: {
                type: String,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
        },
        data: function () {
            return {
                dialogOpen: this.active,
                availabilityUpdated: false,
                availability: this.dayToEdit,
                checkBoxToggleState: true,
                weekDayArray: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
            }
        },

        computed: {
            toggleButtonLabel: function () {
                if (this.checkBoxToggleState) { return 'Select business hours'; }
                else { return 'Deselect business hours'; }
            }
        },// computed

        watch: {
            active: function () {
               
                if (this.active && this.dateToEdit != null && this.dayToEdit == null) {
                    console.log('setting availability to null');
                    this.availability = null;
                    this.loadAvailability();
                    this.availabilityUpdated = false;
                }
                this.dialogOpen = this.active;
            },
            dayToEdit: function () {
                this.availability = this.dayToEdit;
            }
        }, // watch

        methods: {

            getTimeSlotBackground(slot) {
                if ((slot >= this.$config.businessHoursStartTime) && (slot < this.$config.businessHoursEndTime)) return 'businessHourBackGround active'
            },

            loadAvailability: function () {

                var url = this.apiControllerUrl;
                var urlDate = null;
               
                if (!url.endsWith('/')) url += '/';
                urlDate = this.formatDateTime(this.dateToEdit, 'DD/MM/YYYY', true, true)
                url += "day/" + urlDate;

                if (this.userAccountId) {
                    url += '/' + this.userAccountId;
                }
                axios
                    .get(url)
                    .then(response => {
                        this.availability = response.data;
                        console.log('got some availability');
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            saveAvailability: function () {

                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'day';
                if (this.userAccountId) {
                    url += '/' + this.userAccountId;
                }
                axios
                    .post(url, JSON.stringify(this.availability),
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.availabilityUpdated = true;
                        this.dialogOpen = false;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            isPastDate: function () {
                var today = new Date();
                var dateObj = new Date(this.dateToEdit);
                today.setHours(0, 0, 0, 0);
                dateObj.setHours(0, 0, 0, 0);

                console.log((today) + ' | ' + (dateObj));
                console.log(dateObj < today);

                return (dateObj < today);
            },

            toggleCheckboxes: function () {

                for (var i = 0; i < 48; i++) {
                    this.availability.timeSlots[i].selected = false;
                    if (this.availability.timeSlots[i].timeSlotValue >= 800 && this.availability.timeSlots[i].timeSlotValue < 1800)
                        this.availability.timeSlots[i].selected = this.checkBoxToggleState;
                }
                this.checkBoxToggleState = !this.checkBoxToggleState;
                this.availabilityUpdated = true;
            },

            getWeekday(index) {
                return this.weekDayArray[index]
            },

            getVariantColor: function (day) {
                if (day == 'SAT' || day == 'SUN') return 'danger'
                else return 'light'
            },

            onDialogHidden: function () {
                this.checkBoxToggleState = true;
                this.$emit('change', false);
                if (this.availabilityUpdated) {
                    this.$emit('availabilityUpdated', false);
                }
            }
        }, //methods

        mounted: function () {
            // this check makes sure that data is only loaded once a date is passed in
            if (this.dateToEdit != null && this.dayToEdit == null) {
                this.loadAvailability();
            }
        }
    }
</script>

<style scoped>
    .businessHourBackGround {
        background-color: #ddd;
    }
</style>
